// Estilos da barra de filtros da Central de Alertas (FiltrosDashboard),
// no padrão das demais páginas internas: controles renderizados dentro do
// FilterBar compartilhado (components/topBarFilter) — linha única na barra
// em desktop e coluna dentro do Drawer abaixo de 1350px (mesmo breakpoint
// do FilterBar) —, Autocomplete com fonte reduzida (0.75rem, padding 6px
// 8px) e botão de refresh igual ao das telas de dashboard.
const styles = (theme) => ({
  boxControles: {
    display: "flex",
    gap: 1,
    width: "100%",
    minWidth: 0,
    "@media (max-width:1349px)": {
      flexDirection: "column",
    },
  },
  boxPeriodo: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    flexShrink: 0,
    "@media (max-width:1349px)": {
      flexDirection: "column",
      alignItems: "stretch",
      width: "100%",
    },
  },
  autocompleteFilter: {
    width: "100%",
    maxWidth: "500px",
    minWidth: "150px",
    "@media (max-width:1349px)": {
      maxWidth: "100%",
    },
  },
  autocompleteText: {
    fontSize: "0.75rem",
    // Com uma única opção selecionada o renderTagsResumido exibe o nome
    // inteiro, e aí o campo quebrava em duas linhas (40px viravam 60px,
    // desalinhando a barra toda). São duas causas somadas: o contêiner do MUI
    // é flex-wrap: wrap (pensado para chips de tag) e o bloco do nome tem
    // min-width: auto, ou seja, mínimo igual ao min-content — não encolhia e
    // empurrava o <input> para a linha de baixo. Sem quebra e com o bloco
    // podendo encolher, o nome trunca com reticências (o Typography já usa
    // noWrap) e a altura se mantém. Com duas ou mais o texto é curto ("N
    // clientes") e o problema não aparecia.
    "& .MuiAutocomplete-inputRoot": {
      flexWrap: "nowrap",
    },
    "& .tag-resumo-filtro": {
      minWidth: 0,
    },
  },
  tagResumo: {
    overflow: "hidden",
    maxWidth: "100%",
  },
  // Opção do filtro de cliente: checkbox + nome + selo PF/PJ à direita. A
  // lista deste filtro é virtualizada e mede a altura de cada linha, então o
  // padding fica previsível de propósito.
  opcaoCliente: {
    display: "flex",
    alignItems: "center",
    gap: 0.75,
    width: "100%",
    minWidth: 0,
    py: 0.5,
  },
  nomeOpcaoCliente: {
    flex: 1,
    minWidth: 0,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  itemTooltip: {
    fontSize: 10,
  },
  buttonRefresh: {
    minWidth: "40px",
    height: "40px",
    px: 0,
  },
  iconeRefresh: {
    color: theme.palette.text.main,
  },
  botaoLimpar: {
    textTransform: "none",
    whiteSpace: "nowrap",
    flexShrink: 0,
    height: "40px",
  },
});

export default styles;
